import React from 'react'
import ReactGA from 'react-ga'
import { isEmpty, min } from 'lodash'
import InfiniteScroll from 'react-infinite-scroller'
import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
  Link,
} from '@material-ui/core'
import {
  ChevronRight as ChevronRightIcon,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  LocalPhone as PhoneIcon,
  Place as PlaceIcon,
  Public as WebsiteIcon,
  WhatsApp as WhatsAppIcon,
} from '@material-ui/icons'
import ShareIcons from './ShareIcons'
import EmptyList from './EmptyList'
import CircularLoading from './loadings/CircularLoading'
import IconWithLabel from './general/IconWithLabel'
import ActionIcon from './general/ActionIcon'
import { getAtendendoComo } from '../utils/atendendo_como'
import { getFormattedEndereco } from '../utils/estabelecimentos'
import { styles } from '../styles/js/estabelecimentosList'
import { withStyles } from '@material-ui/core'

const EstabelecimentosListComponent = ({
  classes,
  setDialogEstabelecimento,
  estabelecimentosState,
  estabelecimentos,
  statusRequestEstabelecimentos,
  fetchEstabelecimentos,
  searchParams,
  pageProps,
}) => {
  return estabelecimentosState.length > 0 ? (
    statusRequestEstabelecimentos.isLoading && !isEmpty(searchParams) ? (
      <CircularLoading />
    ) : (
      <InfiniteScroll
        pageStart={0}
        loadMore={() => {
          if (
            statusRequestEstabelecimentos.done &&
            !statusRequestEstabelecimentos.isLoading &&
            isEmpty(searchParams)
          ) {
            fetchEstabelecimentos()
            ReactGA.event({
              category: 'User',
              action: 'Fetched next page',
            })
          }
        }}
        hasMore={
          estabelecimentosState.length < min([estabelecimentos.count, 600])
        }
        loader={
          <div key={0} style={{ marginTop: 40 }}>
            <CircularLoading />
          </div>
        }
        threshold={1000}
      >
        <Grid container spacing={2} justify='center'>
          {estabelecimentosState.map(
            (estabelecimento) =>
              estabelecimento.id && (
                <Grid key={estabelecimento.id} item xs={12} sm={6} lg={4}>
                  <Card className={classes.root}>
                    <CardContent className={classes.cardContent}>
                      <Grid
                        container
                        direction='column'
                        justify='space-between'
                        style={{ height: '100%' }}
                      >
                        <Grid item>
                          <Typography
                            variant='h4'
                            className={classes.cardTitle}
                          >
                            {estabelecimento.nome}
                          </Typography>
                          <Typography
                            variant='h6'
                            className={classes.cardCategoriaEstabelecimento}
                          >
                            <span
                              className={classes.cardCategoriaEstabelecimento}
                            >
                              {(estabelecimento.categoria &&
                                estabelecimento.categoria.nome) ||
                                ''}
                            </span>{' '}
                            {(estabelecimento.categoria &&
                              estabelecimento.categoria.nome &&
                              estabelecimento.atendendo_como &&
                              ' • ') ||
                              ''}
                            <span
                              className={`${classes.cardAtendendoComo} ${classes.primary}`}
                            >
                              {getAtendendoComo(estabelecimento.atendendo_como)}
                            </span>
                          </Typography>
                          <br />
                          {estabelecimento.enderecos[0] &&
                            (estabelecimento.enderecos[0].cidade ||
                              estabelecimento.enderecos[0].bairro) && (
                              <Typography
                                variant='h5'
                                className={classes.cardAdress}
                              >
                                {getFormattedEndereco(
                                  estabelecimento.enderecos[0]
                                )}
                              </Typography>
                            )}
                          {estabelecimento.enderecos[0] &&
                            (estabelecimento.enderecos[0].cidade ||
                              estabelecimento.enderecos[0].bairro) && (
                              <Typography paragraph>
                                <Link
                                  target='_blank'
                                  rel='noopener noreferrer'
                                  href={`https://www.google.com/maps?q=${getFormattedEndereco(
                                    estabelecimento.enderecos[0]
                                  )
                                    .trim()
                                    .replace(' ', '')}`}
                                >
                                  Como chegar
                                </Link>
                              </Typography>
                            )}
                          {estabelecimento.enderecos[0] &&
                            estabelecimento.enderecos[0].telefone && (
                              <IconWithLabel
                                Icon={PhoneIcon}
                                value={estabelecimento.enderecos[0].telefone}
                              />
                            )}

                          {estabelecimento.site && (
                            <IconWithLabel
                              Icon={WebsiteIcon}
                              value={estabelecimento.site}
                              href={
                                estabelecimento.site.substring(0, 4) === 'http'
                                  ? `${estabelecimento.site.replace(' ', '')}`
                                  : `https://${estabelecimento.site.replace(
                                      ' ',
                                      ''
                                    )}`
                              }
                            />
                          )}
                        </Grid>

                        <Grid item>
                          <div className={classes.cardActions}>
                            <Grid container justify='space-between'>
                              {estabelecimento.whatsapp && (
                                <ActionIcon
                                  Icon={WhatsAppIcon}
                                  label={'WhatsApp'}
                                  website={`https://api.whatsapp.com/send?phone=55${estabelecimento.whatsapp.replace(
                                    /\D/g,
                                    ''
                                  )}`}
                                />
                              )}
                              {estabelecimento.facebook && (
                                <ActionIcon
                                  Icon={FacebookIcon}
                                  label={'Facebook'}
                                  website={
                                    estabelecimento.facebook.substring(0, 4) ===
                                    'http'
                                      ? `${estabelecimento.facebook.replace(
                                          ' ',
                                          ''
                                        )}`
                                      : `https://facebook.com/${estabelecimento.facebook.replace(
                                          ' ',
                                          ''
                                        )}`
                                  }
                                />
                              )}

                              {estabelecimento.instagram && (
                                <ActionIcon
                                  Icon={InstagramIcon}
                                  label={'Instagram'}
                                  website={
                                    estabelecimento.instagram.substring(
                                      0,
                                      4
                                    ) === 'http'
                                      ? `${estabelecimento.instagram
                                          .replace('@', '')
                                          .replace(' ', '')}`
                                      : `https://instagram.com/${estabelecimento.instagram
                                          .replace('@', '')
                                          .replace(' ', '')}`
                                  }
                                />
                              )}
                            </Grid>

                            <Grid container justify='flex-end'>
                              <Typography
                                variant='h5'
                                className={classes.seeMore}
                                color='primary'
                                onClick={() =>
                                  setDialogEstabelecimento({
                                    isOpen: true,
                                    data: estabelecimento,
                                  })
                                }
                              >
                                <span
                                  style={{ bottom: 6, position: 'relative' }}
                                >
                                  Ver mais
                                </span>{' '}
                                <ChevronRightIcon />
                              </Typography>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              )
          )}
        </Grid>
      </InfiniteScroll>
    )
  ) : statusRequestEstabelecimentos.isLoading &&
    estabelecimentosState.length === 0 ? (
    <CircularLoading />
  ) : (
    <EmptyList />
  )
}

export default withStyles(styles)(EstabelecimentosListComponent)
